export default __webpack_public_path__ + "static/media/logo.87947b58.svg";